/** Quick add bottom sheet controller (touch). Classic script with no module dependencies, so it
 * runs even when the module graph fails to load (e.g. on some iOS Safari versions).
 */
// Quick add bottom sheet (touch): while a sheet is open, an invisible full-screen shield sits
// under it (the sheet lives in the top layer, above everything) and catches every tap outside
// the sheet. A tap there closes the sheet like the X and never reaches the page underneath.
// The shield stays a moment after closing so Safari's delayed synthetic click lands on it too.
if (!window.__quickAddShield) {
  window.__quickAddShield = true;
  let shield;
  let removeTimer;
  const openSheets = () => document.querySelectorAll('.quick-add-panel[popover]:popover-open');
  const scheduleRemove = () => {
    clearTimeout(removeTimer);
    removeTimer = setTimeout(() => shield?.remove(), 450);
  };
  const closeSheets = () => {
    for (const sheet of openSheets()) sheet.hidePopover();
    scheduleRemove();
  };
  const getShield = () => {
    if (shield) return shield;
    shield = document.createElement('div');
    shield.setAttribute('aria-hidden', 'true');
    shield.style.cssText = 'position:fixed;inset:0;z-index:2147483646;background:transparent;touch-action:none;-webkit-tap-highlight-color:transparent;';
    for (const type of ['pointerdown', 'touchstart', 'click']) {
      shield.addEventListener(type, (event) => {
        if (event.cancelable && type !== 'touchstart') event.preventDefault();
        event.stopPropagation();
        if (type === 'click' || type === 'pointerdown') closeSheets();
      }, { passive: type !== 'touchstart' ? false : true });
    }
    return shield;
  };
  // Scroll lock while a sheet is open: overflow on the root only (on body it would make body its
  // own scroll box and unstick the header), plus blocked touch/wheel moves outside the sheet.
  let lockedY = null;
  const lockScroll = () => {
    if (lockedY !== null) return;
    lockedY = window.scrollY;
    // No body repositioning: the page stays where it is, so the sticky header stays visible.
    document.documentElement.style.overflow = 'hidden';
  };
  const unlockScroll = () => {
    if (lockedY === null) return;
    lockedY = null;
    document.documentElement.style.overflow = '';
  };
  const pointInSheet = (x, y) => [...openSheets()].some((sheet) => {
    const r = sheet.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  });
  // Touch moves outside the sheet never scroll the page; the sheet's own list can still scroll.
  // Checked by coordinates: Safari reports touches on the dimmed backdrop with the sheet as target.
  window.addEventListener('touchmove', (event) => {
    if (lockedY === null) return;
    const touch = event.touches[0];
    if (touch && pointInSheet(touch.clientX, touch.clientY)) return;
    if (event.cancelable) event.preventDefault();
  }, { capture: true, passive: false });
  window.addEventListener('wheel', (event) => {
    if (lockedY === null) return;
    if ([...openSheets()].some((sheet) => sheet.contains(event.target))) return;
    event.preventDefault();
  }, { capture: true, passive: false });
  // Backup for browsers that do not report the popover toggle: sync right after the "+" or X tap.
  const sync = () => {
    if (openSheets().length) {
      clearTimeout(removeTimer);
      if (!getShield().isConnected) document.body.append(getShield());
      lockScroll();
    } else if (lockedY !== null) {
      unlockScroll();
      scheduleRemove();
    }
  };
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[commandfor]') : null;
    if (!button) return;
    const target = document.getElementById(button.getAttribute('commandfor'));
    if (!target || !target.matches('.quick-add-panel[popover]')) return;
    setTimeout(sync, 0);
    setTimeout(sync, 120);
  });
  document.addEventListener('toggle', (event) => {
    const sheet = event.target;
    if (!(sheet instanceof HTMLElement) || !sheet.matches('.quick-add-panel[popover]')) return;
    if (event.newState === 'open') {
      clearTimeout(removeTimer);
      document.body.append(getShield());
      lockScroll();
    } else if (!openSheets().length) {
      unlockScroll();
      scheduleRemove();
    }
  }, true);
}

